import React, { FC, useEffect } from 'react'
import { PAGE_MODE } from '../utils/pageMode'
import { BtText } from '@linqpal/components/src/ui'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'

interface IProps {
  onRedirect: () => void
  wrapperStyle?: any
}

const REDIRECT_DELAY_SECONDS = 5

export const ECommerceRedirectionLabel: FC<IProps> = ({
  onRedirect,
  wrapperStyle,
}) => {
  const { t } = useTranslation('global')

  const queryParams = new URLSearchParams(window.location.search)
  const mode = queryParams.get('mode') as PAGE_MODE

  const [redirectDelay, setRedirectDelay] = React.useState(
    REDIRECT_DELAY_SECONDS,
  )

  const canRedirect = mode === PAGE_MODE.REDIRECT || mode === PAGE_MODE.POPUP

  useEffect(() => {
    if (canRedirect) {
      const refreshTimer = setInterval(() => {
        setRedirectDelay((current) => current - 1)
      }, 1000)

      const redirectTimer = setTimeout(() => {
        onRedirect()
      }, REDIRECT_DELAY_SECONDS * 1000)

      return () => {
        clearInterval(refreshTimer)
        clearTimeout(redirectTimer)
      }
    }

    return
  }, [canRedirect, mode, onRedirect])

  if (!canRedirect) return null

  return (
    <View style={wrapperStyle ?? {}}>
      <BtText style={styles.label}>
        {redirectDelay > 0
          ? t('generic.paid-invoice-redirection-label', { redirectDelay })
          : t('generic.paid-invoice-redirecting-label')}
        {}
      </BtText>
    </View>
  )
}

const styles = StyleSheet.create({
  label: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    color: '#001929',
    alignSelf: 'center',
  },
})
